<template>
  <div class="main-wrapper">
    <div class="main-page">
      <projects
        :openEditProjectModal="openEditProjectModal"
        :loading="isProjectsLoading"
        @projectsUpdated="fetchProjects"
        @createProjectClick="openCreateProjectModal"
        :projects="projects"
      />

      <main-info-block :showBiblio="showBiblio" />
    </div>

    <!-- Модалки -->

    <!-- Новый проект / редактирование проекта -->
    <create-project
      @update:project="updateProject"
      @create="addProject"
      @onResetProject="resetProjectData"
      :title="currentProject ? 'Настройки проекта' : 'Создание проекта'"
      :project="currentProject"
    />

    <!-- Настройка профиля -->
    <b-modal id="modal-settings" size="xl" ref="modalUserSettings" hide-footer title="Настройка профиля">
      <settings ref="userSettings"></settings>
    </b-modal>

    <modal-wrapper
      dialogClass="modal-keys-wrapper"
      modalId="modal-keys"
      ref="modal-keys"
      hide-footer
      title="Лицензия"
      @onCancelClick="$bvModal.hide('modal-keys')"
    >
      <keys />
    </modal-wrapper>

    <!-- Приобрести лицензию -->
    <b-modal id="payment" ref="payment" size="xl" hide-footer title="Приобрести лицензию">
      <payment @hide="$refs.payment.hide()"></payment>
    </b-modal>

    <!-- Просмотр документа -->
    <b-modal id="manual" hide-footer hide-header size="xl">
      <iframe src="biblio/manual.pdf" style="width: 100%; height: 90vh"></iframe>
    </b-modal>
    <b-modal id="instruction" hide-footer hide-header size="xl">
      <iframe src="biblio/Instruction.pdf" style="width: 100%; height: 90vh"></iframe>
    </b-modal>
    <b-modal id="biblioWindow" ref="biblioWindow" hide-footer hide-header size="xl">
      <iframe :src="cur_document" style="width: 100%; height: 90vh"></iframe>
    </b-modal>
  </div>
</template>

<style scoped>
.main-wrapper {
  flex: 1 0;
  max-height: calc(100vh - 60px);
}
.main-page {
  display: grid;
  grid-template-columns: 24fr 19fr;
  gap: 48px;
  height: 100%;
  padding: 16px 32px;
}

@media screen and (max-width: 900px) {
  .main-page {
    display: block;
    overflow: auto;
  }
}

fieldset {
  border: unset !important;
}
.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4) !important;
}
</style>

<script>
import Projects from "../components/MainProjects.vue";
import settings from "./user/settings";
import keys from "./keys";
import payment from "./payment";
import MainInfoBlock from "../components/MainInfoBlock.vue";
import CreateProjectModal from "../components/modals/CreateProjectModal.vue";
import ModalWrapper from "../components/modals/ModalWrapper.vue";
import Keys from "./keys.vue";

export default {
  name: "Risk",
  data() {
    return {
      cur_document: null,
      projects: [],
      isProjectsLoading: true,
      currentProject: null,
    };
  },
  components: {
    "create-project": CreateProjectModal,
    settings,
    keys,
    payment,
    Projects,
    MainInfoBlock,
    ModalWrapper,
    Keys,
  },

  created() {
    this.fetchProjects();
  },

  mounted() {
    if (this.$route.query.nolicense) {
      this.$bvModal.show("modal-keys");
    }
  },

  methods: {
    showBiblio(doc) {
      this.cur_document = doc;
      this.$refs.biblioWindow.show();
    },

    goToPhone() {
      this.$refs.keys.hide();
      this.$refs.modalUserSettings.show();
      this.$nextTick(() => {
        this.$refs.userSettings.setSecurity();
      });
    },

    addProject(model) {
      this.hideCreateProjectModal();
      this.$parent.$router
        .push("/risk/" + model.id)
        .then(() => {
          this.fetchProjects();
        })
        .catch((err) => console.error(err));
    },

    updateProject() {
      this.fetchProjects();
      this.resetProjectData();
    },

    fetchProjects() {
      this.isProjectsLoading = true;
      this.$http
        .get("projects/get")
        .then((response) => {
          // JSON responses are automatically parsed.
          this.projects = response.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.isProjectsLoading = false;
        });
    },

    openCreateProjectModal() {
      this.$bvModal.show("new-project");
    },

    hideCreateProjectModal() {
      this.$bvModal.hide("new-project");
      this.resetProjectData();
    },

    openEditProjectModal(project) {
      this.currentProject = project;
      this.openCreateProjectModal();
    },

    resetProjectData() {
      this.currentProject = null;
    },
  },
};
</script>

<style>
.modal-keys-wrapper {
  max-width: 850px;
}
</style>
